// Web (P0.10): o timer aparece no título da aba — "12:34 · Nome da tarefa".
import { useEffect } from 'react';
import type { Task } from '../domain/task';
import { timerView } from '../domain/timer';
import { useAppState } from './AppStore';
import { useNow } from './useNow';

export const APP_TITLE = 'Bee Do It';

export function tabTitle(running: Task | null, nowMs: number): string {
  if (!running) return APP_TITLE;
  return `${timerView(running, nowMs).text} · ${running.title}`;
}

export function useTabTitle(): void {
  const now = useNow();
  const running = useAppState((s) => s.tasks.find((t) => t.status === 'running') ?? null);
  useEffect(() => {
    document.title = tabTitle(running, now);
  }, [running, now]);
  useEffect(() => () => void (document.title = APP_TITLE), []);
}
